import Vue from 'vue'
import SwebScanAnalytics from '../plugin/SwebScanAnalytics'
Vue.use(SwebScanAnalytics)

export default SwebScanAnalytics
